<template>
  <div class="animated fadeIn">
    <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3">
      <div class="d-flex align-items-center p-3">
        <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);">
          <i class="fa fa-shopping-basket text-white"></i>
        </div>
        <div class="header-text-container">
          <h4 class="mb-0 font-weight-bold text-dark">Compra de Gado</h4>
          <p class="text-muted mb-0 small">Gerenciamento e consulta de compras de gado</p>
        </div>
      </div>
      <div class="d-flex align-items-center flex-wrap gap-2 p-3">
          <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
            <i class="fa fa-plus-circle mr-2"></i>
            <span>Nova Compra</span>
          </b-button>
      </div>
    </div>

    <div class="px-0 pb-4">
        <div class="card card-filter-premium p-4 border-0 shadow-sm">
          <form @submit.stop.prevent="filtrar">
            <b-row align-v="end">
              <b-col sm="12" md="3">
                <label class="font-weight-bold text-muted small">Tipo de Situação</label>
                <b-form-select id="comboTipoSituacao" class="custom-select-premium" v-model="tipoSituacao" :options="tipoSituacaoOptions">
                </b-form-select>
              </b-col>
              <b-col sm="12" md="3">
                <label class="font-weight-bold text-muted small">Número do GTA</label>
                <b-form-input type="text" id="documento" class="custom-input-premium" placeholder="Número do GTA" v-model="documento"></b-form-input>
              </b-col>
              <b-col sm="12" md="2">
                <label class="font-weight-bold text-muted small">Nº Controle</label>
                <b-form-input type="text" id="id" class="custom-input-premium" placeholder="ID" v-model="id"></b-form-input>
              </b-col>
              <b-col sm="12" md="4">
                <cliente-pesquisa 
                  @retornaId="clienteId = $event"
                  :idInicial="clienteId"
                  label="Fornecedor"
                  place="Informe o Fornecedor"
                  labelBotao=""
                  ref="clientepesquisa"
                  idModal="clientepesquisa">
                </cliente-pesquisa>
              </b-col>
            </b-row>
            <b-row class="mt-3" align-v="end">
              <b-col sm="12" md="3">
                <cec-input-data
                  label="Período Abate (Início)"
                  v-model="dt1"
                  :required="submmited"
                />
              </b-col>
              <b-col sm="12" md="3">
                <cec-input-data
                  label="Período Abate (Fim)"
                  v-model="dt2"
                  :required="submmited"
                />
              </b-col>
              <b-col class="d-flex align-items-end justify-content-end">
                <div class="d-flex gap-2">
                  <b-button variant="link" class="text-danger" @click.stop.prevent="limpar()">
                    <i class="fa fa-ban mr-2"></i> Limpar
                  </b-button>
                  <vue-button-spinner 
                    type="submit" 
                    :classDefault="'btn-primary btn-pill px-4 shadow-sm'" 
                    :isLoading="isLoading" 
                    :disabled="isLoading"
                    :status="status">
                    <i class="fa fa-search mr-2"></i> Pesquisar
                  </vue-button-spinner>
                </div>
              </b-col>
            </b-row>
          </form>
        </div>
    </div>

    <b-row class="ml-0 mr-0 p-0">
      <b-col sm="12" class="p-0">
          <b-table class="modern-premium-table"
                  show-empty
                  empty-text="Nenhuma compra encontrada"
                  stacked="md"
                  responsive 
                  hover 
                  select-mode="single"
                  selectable
                  @row-selected="edit"
                  :busy.sync="isBusyListagem" 
                  :items="lista" 
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :tbody-tr-class="rowClassSelecionado"
                  >
            <template #cell(OP_STATUS_TRADUZIDO)="item" >
              <b-badge :variant="variantStatus(item.item.OP_STATUS)" class="px-3 py-2 rounded-pill">
                {{item.item.OP_STATUS_TRADUZIDO}}
              </b-badge>
            </template>
            <template #cell(actions)="item">
              <div class="d-flex justify-content-end gap-1">
                <b-button v-if="item.item.OP_STATUS != 0" type="button" @click="abrirModalEstorno(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir compra" v-b-tooltip.hover>
                  <i class="fa fa-trash"></i>
                </b-button>
                <b-overlay
                  :show="pesquisa.impressao.busy"
                  rounded
                  opacity="0.6"
                  spinner-small
                  spinner-variant="warning"
                  class="d-inline-block"
                >
                  <b-button
                    ref="botaoImpressao"
                    :disabled="pesquisa.impressao.busy"
                    variant="soft-primary"
                    pill
                    class="btn-icon-only shadow-sm"
                    @click.stop.prevent="imprimir(item.item)"
                    title="Imprimir"
                    v-b-tooltip.hover>
                      <i class="fa fa-print"></i>
                  </b-button>
                </b-overlay>
              </div>
            </template>

            <template slot="bottom-row">
              <td v-for="(field, idx) in fields" :key="idx" class="bg-light font-weight-bold text-dark border-top">
                <template v-if="field.key === 'ID'">
                  Total: {{ lista.length }}
                </template>
                <template v-else-if="field.key === 'VL_TOTAL'">
                  {{ lista.reduce((acc, item) => acc + (item.VL_TOTAL || 0), 0) | money }}
                </template>
                <template v-else></template>
              </td>
            </template>
          </b-table>
          
          <div class="justify-content-center row my-1">
            <b-pagination size="md" :total-rows="this.lista.length" :per-page="perPage" v-model="currentPage" />
          </div>
        </b-col>
      </b-row>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                          MODAL ESTORNO 
            ----------------------------------------------------------------------------------- -->
        <b-modal id="modal-estorno" 
                 ref="modal-estorno"
                 size="lg" 
                 centered
                 header-class="p-0 border-0"
                 body-class="p-0"
                 footer-class="d-flex justify-content-end border-top-0 p-3"
                 @shown="focusModalEstornar()"
                 hide-header-close>
          <template #modal-header>
            <div class="modal-header-premium w-100 d-flex align-items-center justify-content-between p-3" style="background: linear-gradient(135deg, #f85032 0%, #e73827 100%);">
              <div class="d-flex align-items-center">
                <div class="header-icon-wrapper mr-3" style="background: rgba(255,255,255,0.2);">
                  <i class="fa fa-exclamation-triangle text-white"></i>
                </div>
                <div>
                  <h5 class="modal-title text-white font-weight-bold mb-0">Estorno de Compra</h5>
                  <small class="text-white-50">Confirme os dados para realizar o estorno</small>
                </div>
              </div>
              <b-button variant="link" class="text-white p-0" @click="$bvModal.hide('modal-estorno')">
                <i class="fa fa-times"></i>
              </b-button>
            </div>
          </template>

          <b-overlay :show="estorno.parametros.overlayBaixando" 
                      no-wrap 
                      fixed 
                      z-index="1100" 
                      spinner-variant="primary"
                      spinner-type="border">
            <template #overlay>
              <div class="text-center">
                <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
                <p>Por favor. Aguarde!!!...</p>
              </div>
            </template>
          </b-overlay>

          <div class="modal-info-bar-premium d-flex align-items-center p-3 mb-3" style="background: #fff5f5; border-left: 4px solid #f85032;">
            <i class="fa fa-info-circle text-danger mr-3"></i>
            <span class="text-dark small">Atenção: Esta operação é irreversível e cancelará todos os registros vinculados a esta compra.</span>
          </div>

          <div class="p-4">
            <b-row class="mb-4">
              <b-col md="6">
                <div class="summary-card-premium p-3 rounded shadow-sm border-0 h-100" style="background: #f8f9fa;">
                  <label class="text-muted small font-weight-bold text-uppercase mb-2 d-block">Fornecedor</label>
                  <h6 class="mb-0 font-weight-bold text-dark">{{estorno.dados.nomeCliente}}</h6>
                </div>
              </b-col>
              <b-col md="6">
                <div class="summary-card-premium p-3 rounded shadow-sm border-0 h-100" style="background: #f8f9fa;">
                  <label class="text-muted small font-weight-bold text-uppercase mb-2 d-block">GTA / Valor</label>
                  <h6 class="mb-0 font-weight-bold text-dark">{{estorno.dados.gta}} - {{estorno.dados.valorDocumento | money}}</h6>
                </div>
              </b-col>
            </b-row>

            <b-row v-if="estorno.parametros.permissao === false">
              <b-col cols="12">
                <div class="alert alert-danger border-0 shadow-sm d-flex align-items-center">
                  <i class="fa fa-lock mr-3 fa-2x"></i>
                  <strong>USUÁRIO SEM PERMISSÃO PARA ESTORNAR!</strong>
                </div>
              </b-col>
            </b-row>

            <b-row v-if="estorno.parametros.permissao === true">
              <b-col cols="12">
                <b-form-group label="Motivo do Estorno" label-class="font-weight-bold text-muted small">
                  <b-form-textarea 
                    id="motivoEstorno" 
                    v-model="estorno.dados.motivo" 
                    rows="3"
                    class="custom-input-premium"
                    placeholder="Descreva detalhadamente o motivo do estorno..."
                    :state="validouCampo_motivoEstorno"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </div>

          <template #modal-footer="{ cancel }">
            <b-button variant="light" class="btn-premium-rounded px-4 mr-2" @click="cancel()">
              Cancelar
            </b-button>
            <b-button v-if="estorno.parametros.permissao === true" variant="danger" class="btn-premium-rounded px-4" @click="estornar()">
              <i class="fa fa-check-circle mr-2"></i> Confirmar Estorno
            </b-button>
          </template>
        </b-modal>
    </div>
  </div>
  
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import CecInputData from '../../../components/Cec/CecInputData.vue'
import moment from 'moment'
import {Money} from 'v-money'
import Tools from '../../../tools/tools'

export default {
  components: {
    VueButtonSpinner,
    ClientePesquisa,
    Money,
    CecInputData
  },
  data () {
    return {
      teste: false,
      show: false,
      minimoMoeda: 0,
      formatoMoeda: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      pesquisa: {
        impressao: {
          busy: false
        }
      },
       estorno: {
        parametros: {
          overlayBaixando: false,
          permissao: false,
          processando: false,
          busy: false
        },
        dados: {
          id: null,
          nomeCliente: '',
          documento: '',
          parcela: '',
          motivo: '',
          dataVencimento: 0.00,
          gta: '',
          valorDocumento: 0.00,
          usuario: ''
        }
      },
      tipoDocumentoOptions: [
        { value: '0', text: 'GTA' }
      ],
      tipoSituacaoOptions: [
        { value: null, text: 'Todos' },
        { value: '0', text: 'Cancelado' },
        { value: '1', text: 'Lançando' },
        { value: '2', text: 'Fechado' }
      ],
      isLoading: false,
      status: '',
      isBusyListagem: false,
      fields: [
        {
          key: "ID",
          label: 'ID',
          sortable: true,
          thStyle: { width: '5% !important'}
        },
        {
          key: "GTA",
          label: 'GTA',
          sortable: true ,
          thStyle: { width: '10% !important'} 
        },
        {
          key: "OP_STATUS_TRADUZIDO",
          label: 'Status',
          sortable: true ,
          thStyle: { width: '8% !important'} 
        },
        {
          key: "DT_ABATE",
          label: 'Data Abate',
          sortable: true,
          thStyle: { width: '10% !important'},
          formatter: (value, key, item) => 
            moment(String(value)).format('DD/MM/YYYY') 
        },
        {
          key: "NOME_FORNECEDOR",
          label: 'Fornecedor',
          sortable: true,
          thStyle: { width: '15% !important'}  
        },
        {
          key: "NOME",
          label: 'Comprador',
          sortable: true,
          thStyle: { width: '10% !important'},
          formatter: (value, key, item) => 
              (value === null ? '' : value.substring(0, 8).concat('...'))
        },
        {
          key: "NR_VACA_PECAS_TOTAL",
          label: 'Vaca',
          sortable: true,
          thStyle: { width: '5% !important'}  
        },
        {
          key: "NR_BOI_PECAS_TOTAL",
          label: 'Boi',
          sortable: true,
          thStyle: { width: '5% !important'}  
        },
        {
          key: "NR_TOURO_PECAS_TOTAL",
          label: 'Touro',
          sortable: true,
          thStyle: { width: '6% !important'}  
        },
        {
          key: "NR_NOVILHA_PECAS_TOTAL",
          label: 'Novil',
          sortable: true,
          thStyle: { width: '6% !important'}  
        },
        {
          key: "DT_VENCIMENTO",
          label: 'Vencimento',
          sortable: true,
          thStyle: { width: '8% !important'},
          formatter: (value, key, item) => 
            moment(String(value)).format('DD/MM/YYYY') 
        },
        {
          key: 'VL_TOTAL_BRUTO', 
          class:'text-right', 
          label: 'Valor (R$)', 
          sortable: true,
          thStyle: { width: '9% !important'},
          formatter: (value, key, item) => 
            (value === null ? null : value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}))
        },
        {
          key: "actions" ,
          label: 'Ações',
          class:'text-right',
          thStyle: { width: '13% !important'} 
        }
      ],
      perPage: 20,
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      tipoPagamentoOpcoes: [
        { value: '0', text: 'Dinheiro\Carteira' },
        { value: '1', text: 'Depósito Bancário' },
        { value: '2', text: 'Boleto' },
        { value: '3', text: 'Cheque' },
        { value: '4', text: 'Cartão de Crédito' }
      ]
    }
  },
  computed: {
    currentPage: {
      get () {
        return this.$store.getters['compraGado/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("compraGado/SET_PAGINA_ATUAL", value);
      }
    },
    dt1: {
      get () {
        return this.$store.getters['compraGado/DT1']
      }, 
      set (value) {
        this.$store.commit("compraGado/SET_DT1", value);
      }
    },
    dt2: {
      get () {
        return this.$store.getters['compraGado/DT2']
      }, 
      set (value) {
        this.$store.commit("compraGado/SET_DT2", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['compraGado/ID']
      }, 
      set (value) {
        this.$store.commit("compraGado/SET_ID", value);
      }
    },
    documento: {
      get () {
        return this.$store.getters['compraGado/DOCUMENTO']
      }, 
      set (value) {
        this.$store.commit("compraGado/SET_DOCUMENTO", value);
      }
    },
    clienteId: {
      get () {
        return this.$store.getters['compraGado/CLIENTE_ID']
      }, 
      set (value) {
        this.$store.commit("compraGado/SET_CLIENTE_ID", value);
      }
    },
    tipoSituacao: {
      get () {
        return this.$store.getters['compraGado/TIPO_SITUACAO']
      }, 
      set (value) {
        this.$store.commit("compraGado/SET_TIPO_SITUACAO", value);
      }
    },
    lista: {
      get () {
        return this.$store.getters['compraGado/LISTA']
      }, 
      set (value) {
        this.$store.commit("compraGado/SET_LISTA", value);
      }
    },
    validouCampo_motivoEstorno () {      
      let retorno = null
      if (this.estorno.dados.motivo === ''  || this.estorno.dados.motivo === null)   { retorno = false }
      return  retorno
    }
  },
  methods: {
    limpar() {
      this.dt1 = Tools.formatarDataParaInput(Tools.getDataAtual())
      this.dt2 = Tools.formatarDataParaInput(Tools.getDataAtual())
      this.documento = null
      this.clienteId = null
      this.id = null
    },  
    /**************************************************************************************************
     * *************** MODAL ESTORNO **************************************************************
     * *************************************************************************************************/
    async abrirModalEstorno(titulo) {
      this.$store.commit("compraGado/SET_REGISTRO_SELECIONADO_ID", titulo.ID)
      this.estorno.dados.id = titulo.ID
      this.estorno.dados.nomeCliente = titulo.NOME_FORNECEDOR
      this.estorno.dados.documento = 'CG' + titulo.ID
      this.estorno.dados.motivo = ''
      this.estorno.dados.dataVencimento = moment(String(titulo.DT_VENCIMENTO)).format('DD/MM/YYYY')
      this.estorno.dados.gta = titulo.GTA
      this.estorno.dados.valorDocumento = titulo.VL_TOTAL_BRUTO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      this.estorno.dados.usuario = window.localStorage.getItem('login')

      const permissaoPayLoad = {
          login: window.localStorage.getItem('login'),
          permissao: 'AcPropExcluirCompraGado'
      }

      let permissaoResult = null
      try {
        this.$store.commit('controle/setAguardando', true)
        permissaoResult = await this.$http.post(`api/protected/seguranca/validarPermissao`, permissaoPayLoad)
        this.$store.commit('controle/setAguardando', false)
      } catch (err) {
        this.$store.commit('controle/setAguardando', false)
        Tools.exibirMensagem(this.$store, 'Permissão', 'danger', err)
        return
      }
      
      const permissao = permissaoResult?.data?.permissao ?? null
    
      if (!permissao || permissao == false) {
        this.estorno.parametros.permissao = false
        Tools.exibirMensagem(this.$store, 'Permissão', 'warning', 'Usuário não autorizado')
      } else {
        this.estorno.parametros.permissao = true
        this.estorno.parametros.processando = false
        this.estorno.parametros.busy = true
        this.$refs['modal-estorno'].show()
      }
      
    },
    focusModalEstornar() {
      this.$refs.motivoEstorno.focus()
    },

    /* *************** FIM MODAL EXCLUIR **************************************************************/
    rowClassSelecionado(item, type) {
      if (item && type === 'row') {
        return item.ID === this.$store.getters['compraGado/REGISTRO_SELECIONADO_ID'] ? 'table-success' : ''
      }
    },
    variantStatus (value) {
      let $variant
      if (value.trim() === '2') {
        $variant = 'success'
      } else if (value.trim() === '1') {
        $variant = 'warning'
      } else if (value.trim() === '0') {
        $variant = 'danger'
      }
      return $variant
    },
    details (item) {
      alert(JSON.stringify(item.CODIGO))
    },
    edit (item) {
      if (item[0].OP_STATUS.trim() === '0' ) {
        this.$root.$bvToast.toast(`Não é possível alterar a Compra de Gado CANCELADA!!!`, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'warning',
          appendToast: true
        })
        return
      }
      this.$store.commit("compraGado/SET_REGISTRO_SELECIONADO_ID", item[0].ID)
      this.$router.push(`/movimentos/compragado/edit/${item[0].ID}`)
    },
    novo () {
      this.$router.push(`/movimentos/compragado/novo`)
    },
    async estornar() {
      if (this.validouCampo_motivoEstorno) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o motivo')
        return
      }
      this.estorno.parametros.overlayBaixando = true
      const payloadDelete = {
        id: this.estorno.dados.id,
        usuario:  window.localStorage.getItem('login'),
        motivo: this.estorno.dados.motivo
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post('api/protected/compragado/delete', payloadDelete)
        this.isBusyListagem = false
        this.status = true 
        this.estorno.parametros.overlayBaixando = false
        
        this.$refs['modal-estorno'].hide()
      } catch (error) {
        this.$store.commit('controle/setAguardando', false)
        this.estorno.parametros.overlayBaixando = false
        this.isBusyListagem = false
        this.status = true 
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Falha ao cancelar a compra de gado')
        return
      }

      await this.$store.dispatch('compraGado/GERAR_LISTA')
      this.$store.commit('controle/setAguardando', false)
      Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Compra de gado cancelada com sucesso')
    },
    filtrar (ctx) {
      this.$store.commit("compraGado/SET_REGISTRO_SELECIONADO_ID", null)
      this.isBusyListagem = true
      
      this.$store
        .dispatch('compraGado/GERAR_LISTA')
        .then(() => {
          this.isBusyListagem = false
          this.status = true // or success
        }).catch((error) => {
          if (error) {
            this.status = false // or error
          }
        })
    },
    clienteIdRequerido () {
      if ((this.selected === '1') || (this.selected === '2')) {
        return ((clienteId && this.submmited) || (clienteId && !this.submmited))
      } else {
        return true
      }
    },
    imprimir (registro) {
      this.pesquisa.impressao.busy = true
      let id = registro.ID
      let valor = registro.VL_TOTAL_BRUTO
      let usuario = window.localStorage.getItem('login')
      let uri = `/api/protected/relatorios/relCompraGadoEspelhoAssinatura?id=${id}&valor=${valor}&usuario=${usuario}`
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.pesquisa.impressao.busy = false
          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relCompraGadoEspelhoAssinatura.pdf')
          link.download = 'relCompraGadoEspelhoAssinatura.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = 'Romaneio de Compra de Gado'
            }, 2000);
          }
        })
        .catch(erro => {
          this.$toast.error({
            title: 'Erro',
            message: 'Ocorreram erros ao gerar o Relatorio ',
            progressBar: false,
            showMethod: 'shake',
            position: 'top full width'
          })
          this.pesquisa.impressao.busy = false
        })
    }


  },
  created () {
    
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.dt1?.focus()
      
    })
  },
  watch: {
    'clienteId': function () {
      this.clienteIdRequerido()
    }
   
  }
}
</script>
<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/views/movimentos/compragado/CompraGadoListagem.vue